import { forwardRef, ReactElement } from "react";
import { Dialog, DialogContent, Slide } from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { ComponentType } from "react";
import { IFileInfoDialogProps } from "../../../../../../@types/components/fileInfoDialogProps.types";
import "./fileInfoDialog.css";
import { Viewer } from "@react-pdf-viewer/core";
import PdfViewRender from "../../../../../shared/customPdfViewWithTitleDialog/pdfViewerOption/PdfViewerOption";

const Transition: ComponentType<TransitionProps & { children?: ReactElement<any, any> | undefined }> = forwardRef(
	function Transition(props, ref) {
		return <Slide direction="up" ref={ref} {...props} />;
	}
);

const FileInfoDialog = ({
	openDialog,
	image,
	handleCloseCallback,
	purpose,
	title,
	child,
	mimeType
}: IFileInfoDialogProps) => {
	// console.log(openDialog);
	return (
		<>
			<Dialog
				fullScreen={false}
				style={{ zIndex: 60000 }}
				open={openDialog}
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
				onClose={handleCloseCallback}
				maxWidth="lg"
			>
				<DialogContent>
					<div className="fileDialog">
						<div className="heading">
							<h2>{title}</h2>
						</div>
						{mimeType === "image/png" ? (
							<>{image ? <img src={image} width="100%" height="100%" alt="health" /> : null}</>
						) : (
							<>{image ? <PdfViewRender pdfFile={image} /> : null}</>
						)}
						<h2 style={{ color: "#4cb464" }}>Purpose :</h2>
						<div className="purpose">
							<p>{purpose}</p>
						</div>
					</div>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default FileInfoDialog;
